<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<header class="toolbar zindex999">
  <!-- Upper header -->

  <section class="top-header d-flex align-items-center" [ngClass]="
            !searchPriv || isAdminConsole == 'Yes' ? 'fixed-height' : ''
        ">
    @if (smallScreen && StockRoomCreated ) {
    <div class="avantor-menu-toggle d-flex align-items-center" (click)="toggleResponsiveMenu(true)" cdkOverlayOrigin
      #trigger="cdkOverlayOrigin">
      <i class="material-icons"> menu </i>
    </div>
    }
    <a class="avantor-app d-flex" (click)="navigateToHome()">
      <img class="app-logo" src="/images/avantor-logo-white.svg" alt="" width="323" height="25" />
    </a>

    <!-- Global search -->
    <div class="avantor-global-search" [ngClass]="
                !searchPriv || isAdminConsole == 'Yes' ? 'no-display' : ''
            ">
      <div class="d-flex">
        <mat-form-field class="global-search-category" style="margin-bottom: -1.25em">
          <mat-select panelClass="header-search" [(ngModel)]="searchSelect"
            (selectionChange)="searchFilter(searchValue)" [disabled]="!searchPriv || isAdminConsole == 'Yes'">
            <mat-select-trigger>
              <span class="header-search-selected-value">
                @switch (searchSelect) {
                @case ('products') {
                {{ 'products' | translate }}
                }
                @case ('orders') {
                {{ 'orders' | translate }}
                }
                @case ('vendors') {
                {{ 'vendors' | translate | titlecase }}
                }
                @case ('users') {
                {{ 'users' | translate }}
                }
                @case ('download') {
                {{ 'download.centre' | translate }}
                }
                @case ('vwr') {
                {{ 'ime.vwr.site' | translate }}
                }
                @default {
                {{ 'all' | translate }}
                }
                }
              </span>
            </mat-select-trigger>
            <mat-option value="All">
              {{ 'all' | translate }}
            </mat-option>
            <mat-option value="products">{{ 'products' | translate }}
            </mat-option>
            <mat-option value="orders">
              {{ 'orders' | translate }}
            </mat-option>
            <mat-option value="vendors">{{
              'vendors' | translate | titlecase
              }}</mat-option>
            <mat-option value="users">
              {{ 'users' | translate }}
            </mat-option>
            <mat-option value="download">{{
              'download.centre' | translate
              }}</mat-option>
            <mat-option value="vwr">{{
              'ime.vwr.site' | translate
              }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="global-search-field" style="margin-bottom: -1.25em">
          <input matInput autocomplete="off" placeholder="{{ 'search' | translate }}" (focus)="openGlobalSearch()"
            cdkOverlayOrigin #trigger="cdkOverlayOrigin" (keyup)="search($event)"
            (keyup.enter)="navigateToSearchResults($event)" [(ngModel)]="searchValue" [disabled]="!searchPriv" />
          <img src="/icons/search-icon-gradient.svg" style="
                            width: 18px;
                            height: 18px;
                            position: relative;
                            top: -5px;
                            z-index: 999;
                        " alt="" matSuffix (click)="navigateToSearchResults($event)" />
        </mat-form-field>
      </div>
    </div>

    <span class="spacer"></span>
    @if (device != 'xs') {
    <ul class="ml-0 pl-0 avantor-utility d-flex align-items-center">
      <!-- Help menu (tablet view) -->
      @if (isAdminConsole == 'No' && StockRoomCreated && envDetails.isSupportTicketFeatureEnabled) {
      <li class="support-action">
        <button type="button" class="support-btn" [matMenuTriggerFor]="supportMenu" (click)="getUserManaulaId()">
          <span class="support-btn-label">{{ 'ime.support' | translate }}</span>
          <mat-icon class="support-btn-caret">keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu xPosition="before" #supportMenu="matMenu" class="user-menu">
          <button mat-menu-item (click)="onStartChat()" #supportLiveAgentOnline
            [ngClass]="{ 'disabled-button': isChatDisabled }"
            [matTooltip]="isChatDisabled ? ('ime.business.agent.not.available' | translate) : null">
            <div class="d-flex">
              <div class="notif-badge-container">
                <div class="notif-icon" [class.hidden]="isChatDisabled"></div>
              </div>
              <img width="20" height="20" class="menu-icon" src="/icons/bubble-chat-blue.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">{{ 'ime.chat.support' | translate }}</div>
              </div>
            </div>
          </button>
          <button mat-menu-item (click)="openNewsPanel()">
            <div class="d-flex">
              @if (newsCount > 0) {
              <div class="notif-badge-container">
                <div class="notif-icon news">{{ newsCount }}</div>
              </div>
              }
              <img width="20" height="20" class="menu-icon" src="/icons/news-icon-blue.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">{{ 'ime.news.and.updates' | translate }}</div>
              </div>
            </div>
          </button>
          <button mat-menu-item (click)="toggleUserPanel(true)">
            <div class="d-flex"><img width="20" height="20" class="menu-icon" src="/icons/book.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">{{ 'ime.user.manual.v1' | translate }}</div>
              </div>
            </div>
          </button>
          <button mat-menu-item (click)="startTour()">
            <div class="d-flex"><img width="20" height="20" class="menu-icon" src="/icons/diamond-turn-right-solid.svg"
                alt="" />
              <div class="px-1">
                <div class="menu-item-title">{{ 'ime.guided.tour' | translate }}</div>
              </div>
            </div>
          </button>
          <button mat-menu-item (click)="openSupportTicket()">
            <div class="d-flex"><img width="20" height="20" class="menu-icon" src="/icons/help-icon.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">{{ 'ime.support.ticket' | translate }}</div>
              </div>
            </div>
          </button>
          @if (isNewUserStockroomFeatureEnabled) {
          <button mat-menu-item (click)="openNewUserCreation()">
            <div class="d-flex">
              <img width="20" height="20" class="menu-icon" src="/icons/add.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">New User Creation</div>
              </div>
            </div>
          </button>
          }
          @if (isNewUserStockroomFeatureEnabled) {
          <button mat-menu-item (click)="openNewStockroomRequest()">
            <div class="d-flex">
              <img width="20" height="20" class="menu-icon" src="/icons/add.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">New Stockroom Request</div>
              </div>
            </div>
          </button>
          }
          <button mat-menu-item (click)="openFAQs()">
            <div class="d-flex"><img width="20" height="20" class="menu-icon" src="/icons/help-icon.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">{{ 'ime.faqs' | translate }}</div>
              </div>
            </div>
          </button>
        </mat-menu>
      </li>
      }
      @if (isAdminConsole == 'No' && StockRoomCreated && !envDetails.isSupportTicketFeatureEnabled) {
      <li class="mx-1 help-menu">
        <button class="action-button d-flex align-items-center justify-content-center" [matMenuTriggerFor]="getHelpMenu"
          (click)="getUserManaulaId()">
          <mat-icon class="rm-help-mat-icon">help</mat-icon>
        </button>
        <mat-menu xPosition="before" #getHelpMenu="matMenu" class="user-menu">
          <button mat-menu-item (click)="onStartChat()" #liveAgentOnline
            [ngClass]="{ 'disabled-button': isChatDisabled }"
            [matTooltip]="isChatDisabled ? ('ime.business.agent.not.available' | translate) : null">
            <div class="d-flex">
              <div class="notif-badge-container">
                <div class="notif-icon" [class.hidden]="isChatDisabled">
                </div>
              </div>
              <img width="20" height="20" class="menu-icon" src="/icons/bubble-chat-blue.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">
                  {{ 'ime.chat.support' | translate }}
                </div>
              </div>
            </div>
          </button>
          <button mat-menu-item (click)="openNewsPanel()">
            <div class="d-flex">
              @if (newsCount > 0) {
              <div class="notif-badge-container">
                <div class="notif-icon news">
                  {{ newsCount }}
                </div>
              </div>
              }
              <img width="20" height="20" class="menu-icon" src="/icons/news-icon-blue.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">
                  {{ 'ime.news.and.updates' | translate }}
                </div>
              </div>
            </div>
          </button>
          <button mat-menu-item (click)="toggleUserPanel(true)">
            <div class="d-flex">
              <img width="20" height="20" class="menu-icon" src="/icons/book.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">
                  {{ 'ime.user.manual.v1' | translate }}
                </div>
              </div>
            </div>
          </button>
          <button mat-menu-item (click)="startTour()">
            <div class="d-flex">
              <img width="20" height="20" class="menu-icon" src="/icons/diamond-turn-right-solid.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">
                  {{ 'ime.guided.tour' | translate }}
                </div>
              </div>
            </div>
          </button>

          <button mat-menu-item (click)="openSupportTicket()" *ngIf="envDetails.isSupportTicketFeatureEnabled">
            <div class="d-flex">
              <img width="20" height="20" class="menu-icon" src="/icons/diamond-turn-right-solid.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">
                  {{ 'ime.support.ticket' | translate }}
                </div>
              </div>
            </div>
          </button>
          <button mat-menu-item (click)="openFAQs()">
            <div class="d-flex">
              <img width="20" height="20" class="menu-icon" src="/icons/help-icon.svg" alt="" />
              <div class="px-1">
                <div class="menu-item-title">{{ 'ime.faqs' | translate }}</div>
              </div>
            </div>
          </button>
        </mat-menu>
      </li>
      }
      @if (isAdminConsole == 'No' && StockRoomCreated) {
      <li class="avantor-message-btn" style="margin: 0 px">
        <button class="action-button d-flex align-items-center justify-content-center"
          (click)="onmessageAndNotificationsCount()" [routerLink]="SITE_LINK.COMMUNICATIONS.BASE">
          @if (messageAndNotificationsCount > 0) {
          <div class="notif-badge-container">
            <div class="notif-badge d-flex align-items-center justify-content-center">
              {{ messageAndNotificationsCount }}
            </div>
          </div>
          }
          <img width="20" height="20" src="/icons/chat-icon.svg" alt="" />
        </button>
      </li>
      }
      <li class="list-profile" style="margin-left: 20px">
        <button mat-flat-button color="primary" class="username-border" [matMenuTriggerFor]="userMenu">
          <span class="username">
            {{ 'welcome' | translate }},
            {{ userData?.firstName | titlecase }}
          </span>
          <mat-icon class="welc">keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu xPosition="before" #userMenu="matMenu" class="user-menu">
          @if (isAdminConsole == 'No') {
          <button (click)="accountSetting()" mat-menu-item class="btn_auto"
            [routerLink]="SITE_LINK.ACCOUNT_SETTINGS.BASE">
            <div class="d-flex">
              <img class="menu-icon" src="/icons/user-menu-settings-icon.svg" alt="" />
              <div class="px-2">
                <div class="menu-item-title">
                  {{ 'ime.account.settings' | translate }}
                </div>
                <div class="menu-item-description">
                  {{
                  'ime.account.settings.desc' | translate
                  }}
                </div>
              </div>
            </div>
          </button>
          }
          <button mat-menu-item>
            <div class="d-flex">
              <img class="menu-icon" src="/icons/user-menu-apps-icon.svg" alt="" />
              <div class="px-2">
                <div class="menu-item-title">
                  {{ 'ime.sites.applications' | translate }}
                </div>
                <div class="menu-item-description">
                  {{
                  'ime.sites.applications.desc'
                  | translate
                  }}
                  @for (widget of widgetData; track widget) {
                  <div>
                    <a class="menu-item-title jump-url" href="{{ widget.url }}" target="_blank">{{
                      widget.name }}</a>
                  </div>
                  }
                </div>
              </div>
            </div>
          </button>
          <button mat-menu-item (click)="logout()">
            <div class="d-flex align-items-center">
              <img class="menu-icon" src="/icons/user-menu-logout-icon.svg" alt="" />
              <div class="px-2">
                <div class="menu-item-title">
                  {{ 'im.logout' | translate }}
                </div>
              </div>
            </div>
          </button>
        </mat-menu>
      </li>
    </ul>
    }
  </section>

  @if (StockRoomCreated || isAdminConsole != '') {
  <section [ngStyle]="{ display: showHeaderSearch ? 'none' : 'flex' }" class="toolbar-navigations">
    <nav class="avantor-navigations">
      <div class="d-flex align-items-center">
        @if (isAdminConsole == 'No') {
        <div class="nav-item">
          <a class="nav-label d-flex align-items-center" style="text-decoration: none"
            [ngClass]="!activeExpandingMenu ? 'active-label' : ''" routerLink="/app"
            (click)="analyticsEvent('Dashboard','/app')">
            {{ 'dashboard' | translate }}
          </a>
          <div class="active-bar" [ngClass]="!activeExpandingMenu ? 'active' : ''"></div>
        </div>
        }
        @if (isAdminConsole == 'No') {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                            activeExpandingMenu === 'activities'
                                ? 'active-label'
                                : ''
                        " (click)="toggleMenu(1); preventCloseOnClick();">
            {{ 'ime.activities' | translate }}
            <span class="material-icons">{{
              menuOpen && selectedTab === 1
              ? 'expand_less'
              : 'expand_more'
              }}</span>
          </button>
          <div class="active-bar" [ngClass]="
                            activeExpandingMenu === 'activities' ? 'active' : ''
                        "></div>
        </div>
        }
        @if (isAdminConsole == 'No') {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                            activeExpandingMenu === 'overview'
                                ? 'active-label'
                                : ''
                        " (click)="toggleMenu(2); preventCloseOnClick();">
            {{ 'overview' | translate }}
            <span class="material-icons">{{
              menuOpen && selectedTab === 2
              ? 'expand_less'
              : 'expand_more'
              }}</span>
          </button>
          <div class="active-bar" [ngClass]="
                            activeExpandingMenu === 'overview' ? 'active' : ''
                        "></div>
        </div>
        }
        @if (isAdminConsole == 'No') {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                            activeExpandingMenu === 'administration'
                                ? 'active-label'
                                : ''
                        " (click)="toggleMenu(3); preventCloseOnClick();">
            {{ 'ime.administration' | translate }}
            <span class="material-icons">{{
              menuOpen && selectedTab === 3
              ? 'expand_less'
              : 'expand_more'
              }}</span>
          </button>
          <div class="active-bar" [ngClass]="
                            activeExpandingMenu === 'administration'
                                ? 'active'
                                : ''
                        "></div>
        </div>
        }
        @if (isShowAdminConsole && isAdminConsole == 'Yes') {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                                    activeExpandingMenu === 'organization'
                                        ? 'active-label'
                                        : ''
                                " (click)="toggleMenu(4); preventCloseOnClick();">
            {{ 'organization' | translate }}
            <span class="material-icons">{{
              menuOpen && selectedTab === 4
              ? 'expand_less'
              : 'expand_more'
              }}</span>
          </button>
          <div class="active-bar" [ngClass]="
                                    activeExpandingMenu === 'organization'
                                        ? 'active'
                                        : ''
                                "></div>
        </div>
        }
        @if (isShowAdminConsole && isAdminConsole == 'Yes' && envDetails.isAdminBarcodeMaintenanceFeatureEnabled) {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                                    navBarcoding.isActive ? 'active-label' : ''
                                " [routerLink]="SITE_LINK.ADMIN_MANAGE_BARCODING.BASE" routerLinkActive
            #navBarcoding="routerLinkActive">
            {{ 'ime.barcoding' | translate }}
          </button>
          <div class="active-bar" [ngClass]="
                                    navBarcoding.isActive ? 'active' : ''
                                "></div>
        </div>
        }
        @if (isAdminConsole == 'Yes' && envDetails.isGlobalMetricsFeatureEnabled) {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                                    navGlobalMetrics.isActive ? 'active-label' : ''
                                " [routerLink]="SITE_LINK.ADMIN_GLOBAL_METRICS.BASE" routerLinkActive
            #navGlobalMetrics="routerLinkActive"
            (click)="analyticsEvent('Global Metrics',SITE_LINK.ADMIN_GLOBAL_METRICS.BASE)">
            Global Metrics
          </button>
          <div class="active-bar" [ngClass]="
                                    navGlobalMetrics.isActive ? 'active' : ''
                                "></div>
        </div>
        }
        @if (isAdminConsole == 'Yes' && isEnableLanguageKeyFeature) {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                                    navLanguageKeys.isActive ? 'active-label' : ''
                                " [routerLink]="SITE_LINK.ADMIN_CONSOLE_LANGUAGE_KEY.BASE" routerLinkActive
            #navLanguageKeys="routerLinkActive"
            (click)="analyticsEvent('Language Keys',SITE_LINK.ADMIN_CONSOLE_LANGUAGE_KEY.BASE)">
            {{ 'ime.language.keys' | translate }}
          </button>
          <div class="active-bar" [ngClass]="
                                    navLanguageKeys.isActive ? 'active' : ''
                                "></div>
        </div>
        }
        @if (isAdminConsole == 'Yes' && envDetails.isschedulerFeatureEnabled) {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                                    navScheduling.isActive ? 'active-label' : ''
                                " [routerLink]="SITE_LINK.SCHEDULING.BASE" routerLinkActive
            #navScheduling="routerLinkActive" (click)="analyticsEvent('Scheduling', SITE_LINK.SCHEDULING.BASE)">
            {{ 'Scheduling' | translate }}
          </button>
          <div class="active-bar" [ngClass]="
                                    navScheduling.isActive ? 'active' : ''
                                "></div>
        </div>
        }
        @if (isAdminConsole == 'Yes' && userType === 'SUPER_USER' && (envDetails.isSoftwareCenterFeatureEnabled ||
        envDetails.isDownloadCenterFaqFeatureEnabled)) {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                                    navAdminDownloadCenter.isActive ? 'active-label' : ''
                                " [routerLink]="SITE_LINK.ADMIN_DOWNLOAD_CENTER.BASE" routerLinkActive
            #navAdminDownloadCenter="routerLinkActive"
            (click)="analyticsEvent('Admin Console Download Center', SITE_LINK.ADMIN_DOWNLOAD_CENTER.BASE)">
            {{ 'download.centre' | translate }}
          </button>
          <div class="active-bar" [ngClass]="
                                    navAdminDownloadCenter.isActive ? 'active' : ''
                                "></div>
        </div>
        }
        @if (isAdminConsole == 'Yes') {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                                    navAdminCenterActivityLog.isActive ? 'active-label' : ''
                                " [routerLink]="SITE_LINK.ADMIN_CENTER_ACTIVITY_LOG.BASE" routerLinkActive
            #navAdminCenterActivityLog="routerLinkActive"
            (click)="analyticsEvent('Admin Center Activity Log', SITE_LINK.ADMIN_CENTER_ACTIVITY_LOG.BASE)">
            {{ 'Admin Center Activity Log' | translate }}
          </button>
          <div class="active-bar" [ngClass]="
                                    navAdminCenterActivityLog.isActive ? 'active' : ''
                                "></div>
        </div>
        }
        @if (isAdminConsole == 'Yes' && isSupportTicketReportEnabled) {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                                    navSupportTicketReports.isActive ? 'active-label' : ''
                                " [routerLink]="SITE_LINK.ADMIN_CONSOLE_SUPPORT_TICKET_REPORTS.BASE" routerLinkActive
            #navSupportTicketReports="routerLinkActive"
            (click)="analyticsEvent('Support Ticket Reports',SITE_LINK.ADMIN_CONSOLE_SUPPORT_TICKET_REPORTS.BASE)">
            {{ 'Support Ticket Reports' | translate }}
          </button>
          <div class="active-bar" [ngClass]="
                                    navSupportTicketReports.isActive ? 'active' : ''
                                "></div>
        </div>
        }
        @if (
        userPrivileges.downloadCenter && isAdminConsole == 'No'
        ) {
        <div class="nav-item">
          <button class="nav-label d-flex align-items-center" [ngClass]="
                            navDownloadCenter.isActive ? 'active-label' : ''
                        " [routerLink]="SITE_LINK.DOWNLOAD_CENTER.BASE" routerLinkActive
            #navDownloadCenter="routerLinkActive"
            (click)="analyticsEvent('Download Center',SITE_LINK.DOWNLOAD_CENTER.BASE)">
            {{ 'download.centre' | translate }}
          </button>
          <div class="active-bar" [ngClass]="
                            navDownloadCenter.isActive ? 'active' : ''
                        "></div>
        </div>
        }
      </div>
    </nav>
    @if (device != 'xs') {
    <div class="w-100">
      <div class="avantor-toolbar-navigation d-flex align-items-center">
        @if (notificationsCount != 0 && isAdminConsole == 'No') {
        <button class="notification-button" style="margin-right: 22px" mat-icon-button color="primary"
          [matMenuTriggerFor]="headerNotificationMenu" (click)="getNotifications()">
          @if (notificationsCount > 0) {
          <div class="notif-badge-container">
            <div class="notif-badge d-flex align-items-center justify-content-center">
              {{ notificationsCount }}
            </div>
          </div>
          }
          <img class="notif-icon" src="/icons/notification-icon.svg" alt="" />
        </button>
        }
        @if (notificationsCount == 0 && isAdminConsole == 'No') {
        <button class="notification-button" routerLink="communications/notifications" mat-icon-button color="primary">
          <img class="notif-icon" src="/icons/notification-icon.svg" alt="" />
        </button>
        }
        <mat-menu #headerNotificationMenu="matMenu" xPosition="before" class="header-notification">
          @if (isAdminConsole == 'No') {
          <div class="notif-item-container">
            @for (notification of notifications; track notification) {
            <div class="notif-item">
              @if (notification) {
              <div>
                <div class="text-primary font-weight-bold">
                  {{ notification.subject }}
                </div>
                <div class="text-secondary notif-body">
                  <p class="mb-0" [innerHTML]="
                                            notification.isHtmlContent
                                                ? notification.parsedSubject
                                                : notification.body
                                        "></p>
                </div>
                <div class="text-secondary">
                  {{
                  notification.createdDateString || (notification.createdDate | globalDateTime)
                  }}
                </div>
                <mat-divider class="my-1"></mat-divider>
              </div>
              }
            </div>
            }
          </div>
          <div class="notif-footer w-100">
            <a mat-button class="notif-footer-btn w-100 px-1 text-primary text-left font-weight-bold"
              routerLink="communications/notifications">
              {{ 'ime.see.all' | translate }} >>
            </a>
          </div>
          }
        </mat-menu>
        <div class="d-flex align-items-center">
          @if (isAdminConsole == 'No') {
          <div class="lbl-org-stockroom">
            <div>{{ 'organization' | translate | uppercase }}</div>
            <div>{{ 'stockroom' | translate | uppercase }}</div>
          </div>
          }
          <div class="lbl-org-stockroom-val">
            @if (
            currentOrgStockroom && isAdminConsole == 'No'
            ) {
            <div>
              {{ currentOrgStockroom?.organization?.orgName }}
            </div>
            <div>
              {{
              currentOrgStockroom?.stockroom?.stockroomName
              }}
            </div>
            }
            @if (isAdminConsole == 'Yes') {
            <div>
              {{ 'admin.console' | translate }}
            </div>
            }
          </div>
          <button mat-stroked-button class="change-org-stockroom-btn" color="primary"
            (click)="dialogChangeOrganizationStockroom()">
            {{ 'ime.change' | translate }}
          </button>
        </div>
      </div>
    </div>
    }
  </section>
  }

  <section class="toolbar-routes" [ngClass]="selectedTab !== 0 ? 'active-mega-menu' : ''"
    (click)="preventCloseOnClick()">
    <mat-tab-group animationDuration="0" [selectedIndex]="selectedTab" class="header-navigation" header-less-tabs>
      <mat-tab></mat-tab>
      <mat-tab>
        <section class="route-menu">
          <div class="row">
            @if (
            isAdminConsole == 'No' &&
            userData.isImssUser == 1
            ? true
            : userPrivileges.activities.consumeStock
            ? true
            : false
            ) {
            <div class="col-3 route-section">
              <div class="section activities-menu" [routerLink]="
                                    SITE_LINK.ACTIVITY_CONSUME_STOCK.BASE
                                " (click)="analyticsEvent('Consume Stock',SITE_LINK.ACTIVITY_CONSUME_STOCK.BASE)">
                <div class="flexMenu">
                  @if (
                  !userPrivileges.activities
                  .consumeStock
                  ) {
                  <div #enterpriseLabel1 (mouseenter)="onHover(enterpriseLabel1)" class="enterprise">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div [ngClass]="[
                                            userPrivileges.activities
                                                .consumeStock
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]">
                    {{ 'consume.stock' | translate }}
                  </div>
                </div>
                <div class="description">
                  {{ 'ime.consume.stock.desc' | translate }}
                </div>
              </div>
            </div>
            }
            @if (
            isAdminConsole == 'No' &&
            userData.isImssUser == 1
            ? true
            : userPrivileges.activities.receiveStock
            ? true
            : false
            ) {
            <div class="col-3 route-section">
              <div class="section activities-menu" [routerLink]="
                                    SITE_LINK.ACTIVITY_RECEIVE_STOCK.BASE
                                " (click)="analyticsEvent('Receive Stock',SITE_LINK.ACTIVITY_RECEIVE_STOCK.BASE)">
                <div class="flexMenu">
                  @if (
                  !userPrivileges.activities
                  .receiveStock
                  ) {
                  <div #enterpriseLabel3 (mouseenter)="onHover(enterpriseLabel3)" class="enterprise">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div [ngClass]="[
                                            userPrivileges.activities
                                                .receiveStock
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]">
                    {{ 'receive.stock' | translate }}
                  </div>
                </div>
                <div class="description">
                  {{ 'ime.receive.stock.desc' | translate }}
                </div>
              </div>
            </div>
            }
            @if (
            userData.isImssUser == 1
            ? true
            : userPrivileges.activities.createBarcodes
            ? true
            : false
            ) {
            <div class="col-3 route-section">
              <div class="section activities-menu" [routerLink]="
                                    SITE_LINK.ACTIVITY_CREATE_BARCODES.BASE
                                " (click)="analyticsEvent('Create Barcode',SITE_LINK.ACTIVITY_CREATE_BARCODES.BASE)">
                <div class="flexMenu">
                  @if (
                  !userPrivileges.activities
                  .createBarcodes
                  ) {
                  <div #enterpriseLabel5 (mouseenter)="onHover(enterpriseLabel5)" class="enterprise">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div [ngClass]="[userPrivileges.activities.createBarcodes? 'mega-menu-link' : 'disabledLink']">
                    {{ 'create.barcodes' | translate }}
                  </div>
                </div>
                <div class="description">
                  {{ 'ime.create.barcodes.desc' | translate }}
                </div>
              </div>
            </div>
            }
            @if (
            replenishModel == 'CONSUMPTION_MODEL' ||
            replenishModel == 'ON_HAND_MODEL' ||
            replenishModel == 'PUTAWAY_MODEL'
            ) {
            <div class="col-3 route-section">
              @if (
              userType !== 'IMSS_USER' &&
              userPrivileges.activities.scannerFile
              ) {
              <div class="section activities-menu" (click)="palmRunOnHand(replenishModel)">
                <div class="mega-menu-link">
                  {{
                  'ime.scanner.file.replenishment'
                  | translate
                  }}
                </div>
                @if (
                replenishModel == 'ON_HAND_MODEL'
                ) {
                <div class="description">
                  {{
                  'ime.scanner.file.replenishment.desc'
                  | translate
                  }}
                </div>
                }
                @if (
                replenishModel == 'PUTAWAY_MODEL'
                ) {
                <div class="description">
                  {{
                  'ime.put.away'
                  | translate
                  | titlecase
                  }}
                </div>
                }
                @if (
                replenishModel ==
                'CONSUMPTION_MODEL'
                ) {
                <div class="description">
                  @if (
                  palmRunInterpretation !==
                  'PUT_AWAY') {
                  {{
                  'ime.scanner.file.replenishment.desc'
                  | translate
                  }}
                  } @else {
                  {{
                  'ime.put.away'
                  | translate
                  | titlecase
                  }}
                  }
                </div>
                }
              </div>
              }
              @if (
              replenishModel !== 'CONSUMPTION_MODEL' &&
              (userType == 'IMSS_USER' ||
              this.userData.isImssUser == 1)
              ) {
              <div class="section activities-menu">
                <div class="flexMenu">
                  @if (
                  userType == 'IMSS_USER' ||
                  this.userData.isImssUser == 1 ||
                  !userPrivileges.activities
                  .scannerFile
                  ) {
                  <div #enterpriseLabel7 (mouseenter)="
                                                onHover(enterpriseLabel7)
                                            " class="enterprise">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  @if (
                  userType == 'IMSS_USER' ||
                  this.userData.isImssUser == 1 ||
                  !userPrivileges.activities
                  .scannerFile
                  ) {
                  <div class="disabledLink">
                    {{
                    'ime.scanner.file.replenishment'
                    | translate
                    }}
                  </div>
                  }
                </div>
                @if (
                replenishModel === 'ON_HAND_MODEL'
                ) {
                <div class="description">
                  {{
                  'ime.scanner.file.replenishment.desc'
                  | translate
                  }}
                </div>
                }
                @if (
                replenishModel === 'PUTAWAY_MODEL'
                ) {
                <div class="description">
                  {{
                  'ime.put.away'
                  | translate
                  | titlecase
                  }}
                </div>
                }
              </div>
              }
            </div>
            }
            @if (
            userData.isImssUser == 1
            ? true
            : userPrivileges.activities.replenishStock
            ? true
            : false
            ) {
            <div class="col-3 route-section">
              @if (replenishModel === 'CONSUMPTION_MODEL') {
              <div class="section activities-menu" [routerLink]="
                                    SITE_LINK.ACTIVITY_REPLENISH_STOCK.BASE
                                "
                (click)="analyticsEvent('Replenish Stock Consumeption', SITE_LINK.ACTIVITY_REPLENISH_STOCK.BASE)">
                <div>
                  @if (
                  !userPrivileges.activities
                  .replenishStock
                  ) {
                  <div #enterpriseLabel20001 (mouseenter)="
                                            onHover(enterpriseLabel20001)
                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div [ngClass]="[
                                            userPrivileges.activities
                                                .replenishStock
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]">
                    {{ 'replenish.stock' | translate }}
                  </div>
                </div>
                @if (
                replenishModel === 'CONSUMPTION_MODEL'
                ) {
                <div class="description">
                  {{
                  'ime.consumption.mode.desc' | translate
                  }}
                </div>
                }
              </div>
              }
              @if (replenishModel === 'PUTAWAY_MODEL') {
              <div class="section activities-menu" [routerLink]="
                                    SITE_LINK.ACTIVITY_REPLENISH_STOCK.PUT_AWAY
                                "
                (click)="analyticsEvent('Replenish Stock Put Away',SITE_LINK.ACTIVITY_REPLENISH_STOCK.PUT_AWAY)">
                <div>
                  @if (
                  !userPrivileges.activities
                  .replenishStock
                  ) {
                  <div #enterpriseLabel20002 (mouseenter)="
                                            onHover(enterpriseLabel20002)
                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div [ngClass]="[
                                            userPrivileges.activities
                                                .replenishStock
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]">
                    {{ 'replenish.stock' | translate }}
                  </div>
                </div>
                @if (replenishModel === 'PUTAWAY_MODEL') {
                <div class="description">
                  {{ 'ime.put.away' | translate | titlecase }}
                </div>
                }
              </div>
              }
              @if (replenishModel === 'ON_HAND_MODEL') {
              <div class="section activities-menu" [routerLink]="
                                    SITE_LINK.ACTIVITY_REPLENISH_STOCK
                                        .ON_HAND_MODE
                                "
                (click)="analyticsEvent('Replenish Stock On Hand',SITE_LINK.ACTIVITY_REPLENISH_STOCK.ON_HAND_MODE)">
                <div>
                  @if (
                  !userPrivileges.activities
                  .replenishStock
                  ) {
                  <div #enterpriseLabel20003 (mouseenter)="
                                            onHover(enterpriseLabel20003)
                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div [ngClass]="[
                                            userPrivileges.activities
                                                .replenishStock
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]">
                    {{ 'replenish.stock' | translate }}
                  </div>
                </div>
                @if (replenishModel === 'ON_HAND_MODEL') {
                <div class="description">
                  {{ 'on.hand' | translate | titlecase }}
                </div>
                }
              </div>
              }
              @if (replenishModel === 'ISSUANCE_MODEL') {
              <div class="section activities-menu" [routerLink]="
                                    SITE_LINK.ACTIVITY_REPLENISH_STOCK
                                        .ISSUANCE_MODE
                                "
                (click)="analyticsEvent('Replenish Stock Issuance',SITE_LINK.ACTIVITY_REPLENISH_STOCK.ISSUANCE_MODE)">
                <div>
                  @if (
                  !userPrivileges.activities
                  .replenishStock
                  ) {
                  <div #enterpriseLabel20001 (mouseenter)="
                                            onHover(enterpriseLabel20001)
                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div [ngClass]="[
                                            userPrivileges.activities
                                                .replenishStock
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]">
                    {{ 'replenish.stock' | translate }}
                  </div>
                </div>
                <div class="description">
                  {{
                  'ime.replenish.issuance.mode.desc'
                  | translate
                  }}
                </div>
              </div>
              }
            </div>
            }
            <!-- <div class="col route-section" *ngIf="userData.isImssUser == 1 ? true : ( userPrivileges.activities.returnStock ? true : false )">
                      <div class="section activities-menu">
                        <div class="flexMenu">
                          <div [ngClass]="[userPrivileges.activities.returnStock ? 'mega-menu-link' : 'disabledLink' ]">
                            {{ "return.stock" | translate }}
                          </div>
                          <div #enterpriseLabel4 (mouseenter)="onHover(enterpriseLabel4)" class="enterprise" *ngIf="!userPrivileges.activities.returnStock">
                            <div class="enterpriseText">E</div>
                          </div>
                        </div>
                        <div class="description">
                          {{ "ime.return.stock.desc" | translate }}
                        </div>
                      </div>
                    </div> -->
            @if (
            userData.isImssUser == 1
            ? true
            : userPrivileges.activities.approval
            ? true
            : false
            ) {
            <div class="col-3 route-section">
              <div class="section activities-menu" [routerLink]="
                                    SITE_LINK.APPROVAL.CONSUME_REQUEST_APPROVAL
                                " (click)="analyticsEvent('Approval', SITE_LINK.APPROVAL.CONSUME_REQUEST_APPROVAL)">
                <div class="flexMenu">
                  @if (
                  !userPrivileges.activities.approval
                  ) {
                  <div #enterpriseLabel6 (mouseenter)="onHover(enterpriseLabel6)" class="enterprise">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div class="with-badge" [ngClass]="[
                                            userPrivileges.activities.approval
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]">
                    @if (
                    userPrivileges.activities
                    .approval
                    ) {
                    <span matBadge="{{ approvalCount?.totalCount|| 0  }}" matBadgeOverlap="false"></span>
                    }
                    <span class="title">{{ 'approval' | translate }}
                    </span>
                  </div>
                </div>
                <div class="description">
                  {{ 'ime.approval.desc' | translate }}
                </div>
              </div>
            </div>
            }
            @if (
            userData.isImssUser == 1
            ? true
            : userPrivileges.activities.stockCorrection
            ? true
            : false
            ) {
            <div class="col-3 route-section">
              <div class="section activities-menu">
                <div class="flexMenu">
                  @if (
                  userPrivileges.activities
                  .stockCorrection
                  ) {
                  <div class="mega-menu-link" (click)="analyticsEvent('Stock Correction',   SITE_LINK.ACTIVITY_STOCK_CORRECTION
                                                .BASE)" [routerLink]="
                                            SITE_LINK.ACTIVITY_STOCK_CORRECTION
                                                .BASE
                                        " routerLinkActive="router-link-active">
                    {{ 'stock.correction' | translate }}
                  </div>
                  }
                  @if (
                  !userPrivileges.activities
                  .stockCorrection
                  ) {
                  <div #enterpriseLabel8 (mouseenter)="onHover(enterpriseLabel8)" class="enterprise">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  @if (
                  !userPrivileges.activities
                  .stockCorrection
                  ) {
                  <div class="disabledLink">
                    {{ 'stock.correction' | translate }}
                  </div>
                  }
                </div>
                <div class="description">
                  {{
                  'ime.stock.correction.desc' | translate
                  }}
                </div>
              </div>
            </div>
            }
            @if (
            userPrivileges.activities.transferStock
            ? true
            : false
            ) {
            <div class="col-3 route-section">
              <div class="section activities-menu">
                <div class="flexMenu">
                  @if (
                  userPrivileges.activities
                  .transferStock
                  ) {
                  <div class="mega-menu-link"
                    (click)="analyticsEvent('Stock Transfer',   SITE_LINK.ACTIVITY_STOCK_TRANSFER.BASE)" [routerLink]="
                                            SITE_LINK.ACTIVITY_STOCK_TRANSFER
                                                .BASE
                                        " routerLinkActive="router-link-active">
                    {{ 'ime.stock.transfer' | translate }}
                  </div>
                  }
                  @if (
                  !userPrivileges.activities
                  .transferStock
                  ) {
                  <div #enterpriseLabel8 (mouseenter)="onHover(enterpriseLabel8)" class="enterprise">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                </div>
                <div class="description">
                  {{
                  'ime.transfer.stock.from.one.stockroom.to.another'
                  | translate
                  }}
                </div>
              </div>
            </div>
            }
            <!-- newly added -->
            @if (
            userData.isImssUser === 1
            ? true
            : userPrivileges.activities.returnStock
            ? true
            : false
            ) {
            <div class="col-3 route-section">
              <div class="section activities-menu" [routerLink]="
                                    SITE_LINK.ACTIVITY_RETURN_STOCK.BASE
                                " (click)="analyticsEvent('Return Stock',  SITE_LINK.ACTIVITY_RETURN_STOCK.BASE)">
                <div class="flexMenu">
                  @if (
                  !userPrivileges.activities
                  .returnStock
                  ) {
                  <div #enterpriseLabel3 (mouseenter)="onHover(enterpriseLabel3)" class="enterprise">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div [ngClass]="[
                                            userPrivileges.activities
                                                .returnStock
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]">
                    {{ 'return.stock' | translate }}
                  </div>
                </div>
                <div class="description">
                  {{ 'ime.return.stock.desc' | translate }}
                </div>
              </div>
            </div>
            }
          </div>
        </section>
      </mat-tab>
      <mat-tab>
        <section class="route-menu">
          <div class="row">
            <div class="col route-section">
              <div class="section">
                <div class="title">
                  {{ 'overview' | translate | uppercase }}
                </div>
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.overview.requests
                ? true
                : false
                ) {
                <div class="flexMenu">
                  @if (
                  !userPrivileges.overview.requests
                  ) {
                  <div #enterpriseLabel9 (mouseenter)="onHover(enterpriseLabel9)" class="enterprise">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div class="link-2" [routerLink]="SITE_LINK.REQUESTS.BASE" [ngClass]="[
                                            userPrivileges.overview.requests
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]" (click)="analyticsEvent('Requests',  SITE_LINK.REQUESTS.BASE)">
                    {{ 'requests' | translate }}
                  </div>
                </div>
                }
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.overview.orders
                ? true
                : false
                ) {
                <div class="flexMenu">
                  @if (!userPrivileges.overview.orders) {
                  <div #enterpriseLabel15 (mouseenter)="
                                            onHover(enterpriseLabel15)
                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div class="link-2" (click)="analyticsEvent('Orders',  SITE_LINK.ORDERS.BASE)"
                    [routerLink]="SITE_LINK.ORDERS.BASE" routerLinkActive="router-link-active" [ngClass]="[
                                            userPrivileges.overview.orders
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]">
                    {{ 'orders' | translate }}
                  </div>
                </div>
                }
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.overview.products
                ? true
                : false
                ) {
                <div class="flexMenu">
                  @if (
                  !userPrivileges.overview.products
                  ) {
                  <div #enterpriseLabel15 (mouseenter)="
                                            onHover(enterpriseLabel15)
                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div class="link-2" [routerLink]="SITE_LINK.PRODUCTS.BASE"
                    (click)="analyticsEvent('Products',  SITE_LINK.PRODUCTS.BASE)" routerLinkActive="router-link-active"
                    [ngClass]="[
                                            userPrivileges.overview.products
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]">
                    {{ 'products' | translate }}
                  </div>
                </div>
                }

              </div>
            </div>
            <div class="col route-section">
              <div class="section">
                <div class="title">
                  {{ 'activity.log' | translate | uppercase }}
                </div>
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.overview.articleLog
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.overview.articleLog
                  ) {
                  <div class="mega-menu-link link-2" [routerLink]="
                                            SITE_LINK.ACTIVITY_LOG
                                                .ARTICLE_ACTIVITY_LOG
                                        " (click)="analyticsEvent('Article Activity Log',  SITE_LINK.ACTIVITY_LOG
                                                .ARTICLE_ACTIVITY_LOG)">
                    {{ 'article.activity.log' | translate }}
                  </div>
                  }
                  @if (
                  !userPrivileges.overview.articleLog
                  ) {
                  <div #enterpriseLabel10 (mouseenter)="
                                            onHover(enterpriseLabel10)
                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  @if (
                  !userPrivileges.overview.articleLog
                  ) {
                  <div class="disabledLink link-2">
                    {{ 'article.activity.log' | translate }}
                  </div>
                  }
                </div>
                }
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.overview
                .stockroomLog
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.overview.stockroomLog
                  ) {
                  <div class="mega-menu-link link-2" [routerLink]="
                                            SITE_LINK.ACTIVITY_LOG
                                                .STOCKROOM_ACTIVITY_LOG
                                        " (click)="analyticsEvent('Stockroom Activity Log',  SITE_LINK.ACTIVITY_LOG
                                                .STOCKROOM_ACTIVITY_LOG)">
                    {{
                    'stockroom.activity.log'
                    | translate
                    | titlecase
                    }}
                  </div>
                  }
                  @if (
                  !userPrivileges.overview
                  .stockroomLog
                  ) {
                  <div #enterpriseLabel11 (mouseenter)="
                                            onHover(enterpriseLabel11)
                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  @if (
                  !userPrivileges.overview
                  .stockroomLog
                  ) {
                  <div class="disabledLink link-2">
                    {{
                    'stockroom.activity.log'
                    | translate
                    | titlecase
                    }}
                  </div>
                  }
                </div>
                }
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.overview.articleLog
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.overview.articleLog
                  ) {
                  <div class="mega-menu-link link-2" [routerLink]="
                                                                            SITE_LINK.ACTIVITY_LOG
                                                                                .SITE_ACTIVITY_LOG
                                                                        "
                    (click)="analyticsEvent('Site Activity Log',  SITE_LINK.ACTIVITY_LOG.SITE_ACTIVITY_LOG)">
                    {{ 'ime.site.activity.log' | translate }}
                  </div>
                  }
                  @if (
                  !userPrivileges.overview.articleLog
                  ) {
                  <div #enterpriseLabel10 (mouseenter)="
                                                                            onHover(enterpriseLabel10)
                                                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  @if (
                  !userPrivileges.overview.articleLog
                  ) {
                  <div class="disabledLink link-2">
                    {{ 'ime.site.activity.log' | translate }}
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            <div class="col route-section">
              <div class="section">
                <div class="title">
                  {{ 'reporting' | translate | uppercase }}
                </div>
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.overview.reporting
                ? true
                : false
                ) {
                <div class="flexMenu">
                  @if (
                  userPrivileges.overview.reporting
                  ) {
                  <div class="link-2 mega-menu-link" [routerLink]="SITE_LINK.REPORTING.BASE"
                    (click)="analyticsEvent('Reports',  SITE_LINK.REPORTING.BASE)">
                    {{ 'reports' | translate }}
                  </div>
                  }
                  @if (
                  !userPrivileges.overview.reporting
                  ) {
                  <div #enterpriseLabel12 (mouseenter)="
                                            onHover(enterpriseLabel12)
                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  @if (
                  !userPrivileges.overview.reporting
                  ) {
                  <div class="link-2 disabledLink">
                    {{ 'reports' | translate }}
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            <div class="col route-section">
              <div class="section">
                <div class="title">
                  {{
                  'order.tracking' | translate | uppercase
                  }}
                </div>

                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.overview.trackOrder
                ? true
                : false
                ) {
                <div class="flexMenu">
                  @if (
                  userPrivileges.overview.trackOrder
                  ) {
                  <div class="link-2 mega-menu-link" [routerLink]="
                                            SITE_LINK.TRACK_ORDERS.BASE
                                        " (click)="analyticsEvent('Track Orders',  SITE_LINK.TRACK_ORDERS.BASE)">
                    {{ 'ime.track.orders' | translate }}
                  </div>
                  }
                  @if (
                  !userPrivileges.overview.trackOrder
                  ) {
                  <div #enterpriseLabel12 (mouseenter)="
                                            onHover(enterpriseLabel12)
                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  @if (
                  !userPrivileges.overview.trackOrder
                  ) {
                  <div class="link-2 disabledLink">
                    {{ 'ime.track.orders' | translate }}
                  </div>
                  }
                </div>
                }
              </div>
            </div>
          </div>
        </section>
      </mat-tab>
      <mat-tab>
        <section class="route-menu">
          <div class="row">
            @if (
            userData.isImssUser == 1
            ? true
            : (userPrivileges.administration
            .vendorMaintenance || userPrivileges.administration
            .integrationMaintenance)
            ? true
            : false
            ) {
            <div class="col route-section">
              <div class="section">
                <div class="flexMenu">
                  @if (
                  !userPrivileges.administration
                  .vendorMaintenance && !userPrivileges.administration
                  .integrationMaintenance
                  ) {
                  <div #enterpriseLabel13 (mouseenter)="
                                            onHover(enterpriseLabel13)
                                        " class="enterprise">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div class="title">
                    {{ 'vendor' | translate | uppercase }}
                  </div>
                </div>
                @if (userPrivileges.administration.vendorMaintenance) {
                <div class="link-2" [routerLink]="
                                        SITE_LINK.VENDOR_MAINTENANCE.BASE
                                    " routerLinkActive="router-link-active" [ngClass]="[
                                        userPrivileges.administration
                                            .vendorMaintenance
                                            ? 'mega-menu-link'
                                            : 'disabledLink'
                                    ]"
                  (click)="analyticsEvent('Vendor Maintennace',   SITE_LINK.VENDOR_MAINTENANCE.BASE)">
                  {{ 'vendor.maintenance' | translate }}
                </div>
                }
                @if (userPrivileges.administration.integrationMaintenance) {
                <div class="link-2" [routerLink]="SITE_LINK.INTEGRATION_MAINTENANCE.BASE"
                  (click)="analyticsEvent('Integration Maintennace',   SITE_LINK.INTEGRATION_MAINTENANCE.BASE)"
                  routerLinkActive="router-link-active"
                  [ngClass]="[userPrivileges.administration.integrationMaintenance ? 'mega-menu-link' : 'disabledLink']">
                  {{ 'ime.integration.maintenance' | translate }}
                </div>
                }
              </div>
            </div>
            }
            <div class="col route-section">
              <div class="section">
                <div class="title">
                  {{ 'stockroom' | translate | uppercase }}
                </div>
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.administration
                .manageStockroom
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.administration
                  .manageStockroom
                  ) {
                  <div class="mega-menu-link link-2" [routerLink]="
                                            SITE_LINK.MANAGE_STOCKROOM.BASE
                                        "
                    (click)="analyticsEvent('Manage Stockroom',   SITE_LINK.MANAGE_STOCKROOM.BASE)">
                    {{ 'manage.stockroom' | translate }}
                  </div>
                  }
                  <div class="flexMenu">
                    @if (
                    !userPrivileges.administration
                    .manageStockroom
                    ) {
                    <div #enterpriseLabel14 (mouseenter)="
                                                onHover(enterpriseLabel14)
                                            " class="enterpriseBlock">
                      <div class="enterpriseText">E</div>
                    </div>
                    }
                    @if (
                    !userPrivileges.administration
                    .manageStockroom
                    ) {
                    <div class="disabledLink link-2">
                      {{ 'manage.stockroom' | translate }}
                    </div>
                    }
                  </div>
                </div>
                }
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.administration
                .exportImportStockroom
                ? true
                : false
                ) {
                <div class="flexMenu">
                  @if (
                  !userPrivileges.administration
                  .exportImportStockroom
                  ) {
                  <div #enterpriseLabel15 (mouseenter)="
                                            onHover(enterpriseLabel15)
                                        " class="enterpriseBlock">
                    <div class="enterpriseText">E</div>
                  </div>
                  }
                  <div class="link-2" [routerLink]="
                                            SITE_LINK.EXPORT_IMPORT_STOCKROOM
                                                .BASE
                                        "
                    (click)="analyticsEvent('Export Import Stockroom',   SITE_LINK.EXPORT_IMPORT_STOCKROOM.BASE)"
                    [ngClass]="[
                                            userPrivileges.administration
                                                .exportImportStockroom
                                                ? 'mega-menu-link'
                                                : 'disabledLink'
                                        ]">
                    {{
                    'exportimport.stockroom' | translate
                    }}
                  </div>
                </div>
                }
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.administration
                .locationMaintenance
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.administration
                  .locationMaintenance
                  ) {
                  <div class="mega-menu-link link-2" [routerLink]="
                                            SITE_LINK.LOCATION_MAINTENANCE.BASE
                                        "
                    (click)="analyticsEvent('Location Maintennace',   SITE_LINK.LOCATION_MAINTENANCE.BASE)">
                    {{ 'location.maintenance' | translate }}
                  </div>
                  }
                  <div class="flexMenu">
                    @if (
                    !userPrivileges.administration
                    .locationMaintenance
                    ) {
                    <div #enterpriseLabel16 (mouseenter)="
                                                onHover(enterpriseLabel16)
                                            " class="enterpriseBlock">
                      <div class="enterpriseText">E</div>
                    </div>
                    }
                    @if (
                    !userPrivileges.administration
                    .locationMaintenance
                    ) {
                    <div class="disabledLink link-2">
                      {{
                      'location.maintenance'
                      | translate
                      }}
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
            </div>
            <div class="col route-section">
              <div class="section">
                <div class="title">
                  {{ 'im.product' | translate | uppercase }}
                </div>
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.administration
                .productMaintenance
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.administration
                  .productMaintenance
                  ) {
                  <div class="mega-menu-link link-2" [routerLink]="
                                            SITE_LINK.PRODUCT_MAINTENANCE.BASE
                                        "
                    (click)="analyticsEvent('Product Maintenance',   SITE_LINK.PRODUCT_MAINTENANCE.BASE)">
                    {{ 'product.maintenance' | translate }}
                  </div>
                  }
                  <div class="flexMenu">
                    @if (
                    !userPrivileges.administration
                    .productMaintenance
                    ) {
                    <div #enterpriseLabel17 (mouseenter)="
                                                onHover(enterpriseLabel17)
                                            " class="enterpriseBlock">
                      <div class="enterpriseText">E</div>
                    </div>
                    }
                    @if (
                    !userPrivileges.administration
                    .productMaintenance
                    ) {
                    <div class="disabledLink link-2">
                      {{
                      'product.maintenance'
                      | translate
                      }}
                    </div>
                    }
                  </div>
                </div>
                }

                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.administration
                .reference
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.administration
                  .reference
                  ) {
                  <div class="link-2 mega-menu-link" [routerLink]="
                                            SITE_LINK.REFERENCE_CODE_FIELD_UOM
                                                .BASE
                                        "
                    (click)="analyticsEvent('Reference Code Field UOM',   SITE_LINK.REFERENCE_CODE_FIELD_UOM.BASE)">
                    {{
                    'ime.reference.code.field.uom'
                    | translate
                    }}
                  </div>
                  }
                  <div class="flexMenu">
                    @if (
                    !userPrivileges.administration
                    .reference
                    ) {
                    <div #enterpriseLabel19 (mouseenter)="
                                                onHover(enterpriseLabel19)
                                            " class="enterpriseBlock">
                      <div class="enterpriseText">E</div>
                    </div>
                    }
                    @if (
                    !userPrivileges.administration
                    .reference
                    ) {
                    <div class="link-2 disabledLink">
                      {{
                      'ime.reference.code.field.uom'
                      | translate
                      }}
                    </div>
                    }
                  </div>
                </div>
                }

              </div>
            </div>
            <div class="col route-section">
              <div class="section">
                <div class="title">
                  {{ 'user' | translate | uppercase }}
                </div>
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.administration
                .userMaintenance
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.administration
                  .userMaintenance
                  ) {
                  <div class="mega-menu-link link-2" [routerLink]="
                                            SITE_LINK.USER_MAINTENANCE.BASE
                                        "
                    (click)="analyticsEvent('User Maintennace',   SITE_LINK.USER_MAINTENANCE.BASE)">
                    {{ 'user.maintenance' | translate }}
                  </div>
                  }
                  <div class="flexMenu">
                    @if (
                    !userPrivileges.administration
                    .userMaintenance
                    ) {
                    <div #enterpriseLabel21 (mouseenter)="
                                                onHover(enterpriseLabel21)
                                            " class="enterpriseBlock">
                      <div class="enterpriseText">E</div>
                    </div>
                    }
                    @if (
                    !userPrivileges.administration
                    .userMaintenance
                    ) {
                    <div class="disabledLink link-2">
                      {{ 'user.maintenance' | translate }}
                    </div>
                    }
                  </div>
                </div>
                }

                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.administration
                .costCenter
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.administration
                  .costCenter
                  ) {
                  <div class="link-2 mega-menu-link" [routerLink]="
                                            SITE_LINK.COST_CENTER_MAINTENANCE
                                                .BASE
                                        "
                    (click)="analyticsEvent('Cost Center Maintennace',   SITE_LINK.COST_CENTER_MAINTENANCE.BASE)">
                    {{
                    'cost.center.maintenance'
                    | translate
                    }}
                  </div>
                  }
                  <div class="flexMenu">
                    @if (
                    !userPrivileges.administration
                    .costCenter
                    ) {
                    <div #enterpriseLabel22 (mouseenter)="
                                                onHover(enterpriseLabel22)
                                            " class="enterpriseBlock">
                      <div class="enterpriseText">E</div>
                    </div>
                    }
                    @if (
                    !userPrivileges.administration
                    .costCenter
                    ) {
                    <div class="link-2 disabledLink">
                      {{
                      'cost.center.maintenance'
                      | translate
                      }}
                    </div>
                    }
                  </div>
                </div>
                }
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.administration
                .deptMaintenance
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.administration
                  .deptMaintenance
                  ) {
                  <div class="link-2 mega-menu-link" [routerLink]="
                                            SITE_LINK.DEPARTMENT_MAINTENANCE
                                                .BASE
                                        "
                    (click)="analyticsEvent('Department Maintennace',   SITE_LINK.DEPARTMENT_MAINTENANCE.BASE)">
                    {{
                    'department.maintenance' | translate
                    }}
                  </div>
                  }
                  <div class="flexMenu">
                    @if (
                    !userPrivileges.administration
                    .deptMaintenance
                    ) {
                    <div #enterpriseLabel23 (mouseenter)="
                                                onHover(enterpriseLabel23)
                                            " class="enterpriseBlock">
                      <div class="enterpriseText">E</div>
                    </div>
                    }
                    @if (
                    !userPrivileges.administration
                    .deptMaintenance
                    ) {
                    <div class="link-2 disabledLink">
                      {{
                      'department.maintenance'
                      | translate
                      }}
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
            </div>
            <div class="col route-section">
              <div class="section">
                <div class="flexMenu">
                  <div class="title">
                    {{
                    'ime.administration'
                    | translate
                    | uppercase
                    }}
                  </div>
                </div>
                @if (userData.isImssUser == 1? true: userPrivileges.administration
                .reasonCode
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.administration
                  .reasonCode
                  ) {
                  <div class="link-2 mega-menu-link" [routerLink]="
                                                                        SITE_LINK.REASON_CODE_MAINTENANCE
                                                                            .BASE
                                                                    "
                    (click)="analyticsEvent('Reasin Code Maintennace',   SITE_LINK.REASON_CODE_MAINTENANCE.BASE)">
                    {{ 'reason.code.maintenance' | translate }}
                  </div>
                  }
                  <div class="flexMenu">
                    @if (
                    !userPrivileges.administration
                    .reasonCode
                    ) {
                    <div #enterpriseLabel24 (mouseenter)="
                                                                            onHover(enterpriseLabel24)
                                                                        " class="enterpriseBlock">
                      <div class="enterpriseText">E</div>
                    </div>
                    }
                    @if (
                    !userPrivileges.administration
                    .reasonCode
                    ) {
                    <div class="link-2 disabledLink">
                      {{ 'reason.code.maintenance' | translate }}
                    </div>
                    }
                  </div>
                </div>
                }
                @if (
                userData.isImssUser == 1
                ? true
                : userPrivileges.administration
                .messageCenter
                ? true
                : false
                ) {
                <div>
                  @if (
                  userPrivileges.administration
                  .messageCenter
                  ) {
                  <div class="link-2 mega-menu-link" [routerLink]="
                                            SITE_LINK.MESSAGE_CENTER
                                                .BASE
                                        " (click)="analyticsEvent('Message Center',   SITE_LINK.MESSAGE_CENTER.BASE)">
                    {{ 'messaging.center' | translate }}
                  </div>
                  }
                  <div class="flexMenu">
                    @if (
                    !userPrivileges.administration
                    .messageCenter
                    ) {
                    <div #enterpriseLabel25 (mouseenter)="
                                                onHover(enterpriseLabel25)
                                            " class="enterpriseBlock">
                      <div class="enterpriseText">E</div>
                    </div>
                    }
                    @if (
                    !userPrivileges.administration
                    .messageCenter
                    ) {
                    <div class="link-2 disabledLink">
                      {{ 'messaging.center' | translate }}
                    </div>
                    }
                  </div>
                </div>
                }

                @if (
                isShowAdminConsole ||
                isCountryAdminViewOnly
                ) {
                <div>
                  <div class="link-2 mega-menu-link" (click)="
                                            naivgateToAdminConosleOrgView();analyticsEvent('Organization Maintenance',   'app/admin/organization/organization-maintenance/manage-organization/required-settings-normal')
                                        ">
                    {{
                    'organization.maintenance'
                    | translate
                    }}
                  </div>
                </div>
                }

              </div>
            </div>
          </div>
        </section>
      </mat-tab>
      <mat-tab>
        <section class="route-menu">
          <div class="row">
            <div class="col route-section">
              <div class="section">

                @if (
                isShowAdminConsole ||
                isCountryAdminViewOnly
                ) {
                <div>
                  <div class="mega-menu-link link-2" [routerLink]="
                                            SITE_LINK.ADMIN_CONSOLE.BASE
                                        "
                    (click)="analyticsEvent('Admin Console Organization Maintenance',  SITE_LINK.ADMIN_CONSOLE.BASE)">
                    {{
                    'organization.maintenance'
                    | translate
                    }}
                  </div>
                </div>
                }

                <div>
                  <div class="mega-menu-link link-2" [routerLink]="
                                            SITE_LINK.ADMIN_ROLE_MAINTENANCE
                                                .BASE
                                        "
                    (click)="analyticsEvent('Admin Console Role Maintenance',  SITE_LINK.ADMIN_ROLE_MAINTENANCE.BASE)">
                    {{ 'role.maintenance' | translate }}
                  </div>

                </div>
              </div>
            </div>
            <div class="col route-section">
              <div class="section">

                @if (
                isShowAdminConsole ||
                isCountryAdminViewOnly
                ) {
                <div>
                  <div class="mega-menu-link link-2" [routerLink]="
                                                            SITE_LINK.ADMIN_CONSOLE_NEWS_CENTER.BASE
                                                        "
                    (click)="analyticsEvent('Admin Console Create News',  SITE_LINK.ADMIN_CONSOLE_NEWS_CENTER.BASE)">
                    {{
                    'create.news'
                    | translate
                    }}
                  </div>
                  @if (envDetails.isSuperUserandCountryAdminFeatureEnabled) {
                  <div>
                    <div class="mega-menu-link link-2"
                      [routerLink]="SITE_LINK.ADMIN_SUPER_USERS_COUNTRY_VIEWS.SUPER_USERS"
                      (click)="analyticsEvent('Country Admin/ Super User Maintenance',  SITE_LINK.ADMIN_SUPER_USERS_COUNTRY_VIEWS.SUPER_USERS)">
                      {{ 'ime.countryadmin.superuser.maintenance' | translate }}
                    </div>
                  </div>
                  }
                </div>
                }
                @if (envDetails.isAdminConsoleOrderTrackingFeatureEnabled) {
                <div>
                  <div class="mega-menu-link link-2" [routerLink]="SITE_LINK.ADMIN_ORDER_TRACKING.BASE"
                    (click)="analyticsEvent('Admin Console Order Tracking',  SITE_LINK.ADMIN_ORDER_TRACKING.BASE)">
                    {{ 'order.tracking' | translate }}
                  </div>

                </div>
                }
              </div>
            </div>
          </div>
        </section>
      </mat-tab>
    </mat-tab-group>
  </section>
</header>

<!-- GLOBAL SEARCH -->
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOffsetX]="leftOffset" [cdkConnectedOverlayOffsetY]="topOffset"
  [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isGlobalSearchPanelOpen"
  [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="closeGlobalSearch()">
  <section class="overlay-global-search-container">
    <div class="search-panel overflow-auto">
      @if (searchSelect === 'All' || searchSelect === 'products') {
      <div>
        <label class="title" (click)="setSearchValue(searchValue, 'products')">PRODUCTS</label>
        <section>
          @if (productSearchResult?.length > 0) {
          <div>
            @for (product of productSearchResult; track product) {
            <div class="item">
              <p (click)="
                                    setSearchValue(
                                        product.description,
                                        'products'
                                    )
                                " [routerLink]="SITE_LINK.SEARCH_RESULT.PRODUCTS" [innerHTML]="
                                    product.description
                                        | highlight : searchValue
                                "></p>
            </div>
            }
          </div>
          }
          @if (productSearchResult?.length === 0) {
          <div class="item">
            {{ 'no.record.found' | translate }}
          </div>
          }
          <div class="expand-more" (click)="setSearchValue(searchValue, 'products')">
            MORE >>
          </div>
        </section>
      </div>
      }

      @if (searchSelect === 'All' || searchSelect === 'orders') {
      <div>
        <label class="title" (click)="setSearchValue(searchValue, 'orders')">ORDERS</label>
        <section>
          @if (orderSearchResult?.length > 0) {
          <div>
            @for (order of orderSearchResult; track order) {
            <div class="item">
              <p (click)="
                                    setSearchValue(
                                        order.internalOrderNo,
                                        'orders'
                                    )
                                " [innerHTML]="
                                    order.internalOrderNo
                                        | highlight : searchValue
                                "></p>
            </div>
            }
          </div>
          }
          @if (orderSearchResult?.length === 0) {
          <div class="item">
            {{ 'no.record.found' | translate }}
          </div>
          }
          <div class="expand-more" (click)="setSearchValue(searchValue, 'orders')">
            MORE >>
          </div>
        </section>
      </div>
      }
      @if (searchSelect === 'All' || searchSelect === 'vendors') {
      <div>
        <label class="title" (click)="setSearchValue(searchValue, 'vendors')">VENDORS</label>
        <section>
          @if (vendorSearchResult?.length > 0) {
          <div>
            @for (vendor of vendorSearchResult; track vendor) {
            <div class="item">
              <p (click)="
                                    setSearchValue(vendor.vendorName, 'vendors')
                                " [routerLink]="SITE_LINK.SEARCH_RESULT.VENDORS" [innerHTML]="
                                    vendor.vendorName | highlight : searchValue
                                "></p>
            </div>
            }
          </div>
          }
          @if (vendorSearchResult?.length === 0) {
          <div class="item">
            {{ 'no.record.found' | translate }}
          </div>
          }
          <div class="expand-more" (click)="setSearchValue(searchValue, 'vendors')">
            MORE >>
          </div>
        </section>
      </div>
      }
      @if (searchSelect === 'All' || searchSelect === 'users') {
      <div>
        <label class="title" (click)="setSearchValue(searchValue, 'users')">USERS</label>
        <section>
          @if (userSearchResult?.length > 0) {
          <div>
            @for (user of userSearchResult; track user) {
            <div class="item">
              <p (click)="
                                    setSearchValue(formatName(user), 'users')
                                " [routerLink]="SITE_LINK.SEARCH_RESULT.USERS" [innerHTML]="
                                    user.firstName + ' ' + user.lastName
                                        | highlight : searchValue
                                "></p>
            </div>
            }
          </div>
          }
          @if (userSearchResult?.length === 0) {
          <div class="item">
            {{ 'no.record.found' | translate }}
          </div>
          }
          <div class="expand-more" (click)="setSearchValue(searchValue, 'users')">
            MORE >>
          </div>
        </section>
      </div>
      }
      @if (searchSelect === 'All' || searchSelect === 'download') {
      <div>
        <label class="title" (click)="closeGlobalSearch()"
          [routerLink]="SITE_LINK.SEARCH_RESULT.DOWNLOAD_CENTER">DOWNLOAD CENTER</label>
        <section>
          @if (softwareSearchResult?.length > 0) {
          <div>
            @for (software of softwareSearchResult; track software) {
            <div class="item">
              <p (click)="
                                    setSearchValue(
                                        software.description,
                                        'download'
                                    )
                                " [innerHTML]="
                                    software.description
                                        | highlight : searchValue
                                "></p>
            </div>
            }
          </div>
          }
          @if (softwareSearchResult?.length === 0) {
          <div class="item">
            {{ 'no.record.found' | translate }}
          </div>
          }
          <div class="expand-more" (click)="closeGlobalSearch()" [routerLink]="SITE_LINK.SEARCH_RESULT.DOWNLOAD_CENTER">
            MORE >>
          </div>
        </section>
      </div>
      }
      @if (searchSelect === 'vwr') {
      <div>
        <label class="title" (click)="closeGlobalSearch()" [routerLink]="SITE_LINK.SEARCH_RESULT.VWR">VWR.COM</label>
        <section>
          @if (vwrSearchResult?.length > 0) {
          <div>
            @for (vwr of vwrSearchResult; track vwr) {
            <div class="item">
              <p (click)="setSearchValue(vwr.description, 'vwr')" [innerHTML]="
                                    vwr.description | highlight : searchValue
                                "></p>
            </div>
            }
          </div>
          }
          @if (vwrSearchResult?.length === 0) {
          <div class="item">
            {{ 'no.record.found' | translate }}
          </div>
          }
          <div class="expand-more" (click)="closeGlobalSearch()" [routerLink]="SITE_LINK.SEARCH_RESULT.VWR">
            MORE >>
          </div>
        </section>
      </div>
      }
    </div>
  </section>
</ng-template>

<!-- NEWS PANEL -->
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isNewsPanelOpen"
  [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayScrollStrategy]="cdkScrollStrategy"
  (backdropClick)="toggleNewsPanel(false)">
  <app-news-panel [openPanel]="isNewsPanelAnimate" (closePanel)="toggleNewsPanel(false)"
    [newsData]="newsResponseData"></app-news-panel>
</ng-template>

<!-- MESSAGE PANEL -->
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isMessagesPanelOpen"
  [cdkConnectedOverlayScrollStrategy]="cdkScrollStrategy" [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="toggleMessagePanel(false)">
  <app-messages-panel [openPanel]="isMessagesPanelAnimate" (closePanel)="toggleMessagePanel(false)">
  </app-messages-panel>
</ng-template>

<!-- RESPONSIVE MENU PANEL -->
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isResponsiveMenuOpen"
  [cdkConnectedOverlayScrollStrategy]="cdkScrollStrategy" [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="toggleResponsiveMenu(false)">
  <app-responsive-menu [userData]="userData" [openPanel]="isResponsiveMenuAnimate" (toggleData)="onToggleData($event)"
    (closePanel)="toggleResponsiveMenu(false)">
  </app-responsive-menu>
</ng-template>

<!-- USER PANEL V2-->
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isUserPanelOpen"
  [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayScrollStrategy]="cdkScrollStrategy"
  (backdropClick)="toggleUserPanelV2(false)">
  <app-user-manual-panel [openPanel]="isUserPanelAnimate" (closePanel)="toggleUserPanelV2(false)"
    [userManual]="userManualId">
  </app-user-manual-panel>
</ng-template>
